import axios from "axios";

const appHttpClient = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor: attach the JWT as a Bearer token on every outgoing request.
// Single implementation point shared by all services (orders/account/businessCustomer/catalog).
appHttpClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("jwtToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor: centralized handling of an expired/invalid token (401).
// Clears the token and returns the user to an anonymous, working state.
// Note: there is no "/login" route (login is a dialog), so we navigate to home "/".
appHttpClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("jwtToken");
      window.location.assign("/");
    }
    return Promise.reject(error);
  }
);

export { appHttpClient };
